module.exports = __webpack_public_path__ + "img/rowC15.93aa0bec.png";